export enum CountryCodes {
    ireland=372,
    uk=826,
    guernsey=831,
    jersey=832
}